import type { NextRequest } from 'next/server';
import { NextResponse } from 'next/server';
import { getBrandForRequest } from './getBrandForRequest';

export const brandMiddleware = (req: NextRequest): NextResponse | undefined => {
    const brand = getBrandForRequest(req);
    const newUrl = req.nextUrl.clone();
    const brandPathPart = newUrl.pathname.split('/')[0];
    if (brand && brandPathPart !== brand) {
        newUrl.searchParams.set('brand', brand);
        return NextResponse.rewrite(new URL(`/${brand}${newUrl.pathname}${newUrl.search}`, req.url), {
            headers: {
                'X-Brand': brand,
            },
        });
    }
    return;
};
